export type TenantAddon = {
    description: string;
    identifier: string;
    is_available: boolean;
    name: string;
    position: number;
};

export type Workspace = {
    id: string;
    name: string;
    is_root: boolean;
    status?: number;
};

export type OrganizationProfile = {
    changedby: string;
    date: string;
    details: {
        currency: string;
        legal_type: string;
        location: string;
        nr_employees: string;
        segment: string;
        turnover: string;
    };
    version: string;
};

export type TermsAndCondition = {
    accepted_date: string;
    accepted_version: string;
    changed_by: string;
};

export type B2CPolicies = {
    b2c_policy_name: string;
    image: string;
    is_selected: boolean;
    is_vendor: boolean;
    mode: number;
    b2c_instance: {
        instance: string;
        tenant: string;
        client_id: string;
    };
};

export type Tenant = {
    addons: TenantAddon[];
    api_version: number;
    b2Cpolicies: B2CPolicies[];
    b2c_client_id: string;
    b2c_instance: string;
    b2c_tenant: string;
    friendly_name: string;
    is_expired: boolean;
    is_process_publication?: false;
    language: string;
    name: string;
    organization_profile: OrganizationProfile;
    terms_and_conditions: TermsAndCondition | null;
    version: number;
    top_menu_color: string;
    top_menu_font_color: string;
};

export type VisibleObjectDefinition = {
    id: string;
    name: string;
    visible: boolean;
};

export type ObjectDefinitionPermission = {
    id: string;
    can_create_objects: boolean;
    can_delete_objects: boolean;
    can_create_delete_views: boolean;
    can_delete_relations: boolean;
};

export type LastUsedShape = {
    item_id: string;
    timestamp: string;
};

export type LastUsedIcon = {
    id: string;
    template_type: string;
    provider_internal: string;
    name: string;
    icon_path: string;
    width: string;
    height: string;
    timestamp: string;
};

export type BlueDolphinUser = {
    id: string;
    first_name: string;
    last_name: string;
    email: string;
    avatar: string;
    roles: string[];
    isNew: boolean;
    isDeleted: boolean;
    is_guest_user: boolean;
    read_notifications: any[];
    visible_object_definitions: VisibleObjectDefinition[];
    object_definition_permissions: Record<string, ObjectDefinitionPermission>;
    profile: {
        version: string;
        date: string;
        details: {
            function: string[];
            department: string[];
            responsibilities: string[];
            working_with: string[];
        };
    };
    default_landing_page: string;
    last_used_shapes: LastUsedShape[];
    last_used_icons: Record<string, LastUsedIcon[]>;
    default_view_mode: boolean;
    last_log_in: string;
    user_name: string | null;
    external_id: string | null;
    is_scim_provisioned: boolean;
};
